export enum InlineEditorActionType {
    SetSelectionActive,
}

export interface SetSelectionActive {
    type: InlineEditorActionType.SetSelectionActive;
    payload: { hasSelection: boolean };
}

export type InlineEditorAction = SetSelectionActive;
